import { Tag } from 'antd';
import styled from 'styled-components';

export const ProfileWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  align-self: stretch;
  gap: 16px;

  @media (min-width: ${({ theme }) => theme.mediaQueries.md}) {
    flex-direction: row;
    justify-content: flex-start;
  }
`;

export const DescriptionWrapper = styled.div`
  color: ${({ theme }) => theme.colors.black9};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;

export const StyledTag = styled(Tag)`
  padding: 2px 8px;
  background-color: transparent;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.black3};
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column-reverse;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  max-width: 600px;

  @media (min-width: ${({ theme }) => theme.mediaQueries.md}) {
    flex-direction: column;
    max-width: 800px;
  }

  @media (min-width: ${({ theme }) => theme.mediaQueries.lg}) {
    min-width: 516px;
    padding: 20px 0 20px 60px;
  }
`;

export const HeaderRow = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  width: 100%;

  @media (min-width: ${({ theme }) => theme.mediaQueries.md}) {
    justify-content: space-between;
  }
`;

export const AvatarWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 1rem;

  @media (min-width: ${({ theme }) => theme.mediaQueries.md}) {
    justify-content: flex-start;
    width: fit-content;
  }
`;

export const TabTitle = styled.h2`
  overflow: hidden;
  color: ${({ theme }) => theme.colors.black9};
  font-feature-settings: 'liga' off, 'clig' off;
  text-overflow: ellipsis;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 32px;
  letter-spacing: -0.2px;
  display: none;
  margin: 0;

  @media (min-width: ${({ theme }) => theme.mediaQueries.md}) {
    display: flex;
  }
`;

export const ActionsWrapper = styled.div`
  display: flex;
  gap: 16px;
`;

export const ProfileData = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const PasswordWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
`;
